// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__2-faL","productName":"Table_productName__aNqSo"};